import { useLang } from "@/i18n/LanguageContext";

export default function Marquee() {
  const { t } = useLang();
  const track = [...t.marquee, ...t.marquee];
  return (
    <div className="relative py-10 border-y border-white/5 overflow-hidden" dir="ltr" data-testid="marquee-section">
      <div className="flex whitespace-nowrap animate-marquee will-change-transform">
        {track.map((word, i) => (
          <span key={i} className="flex items-center shrink-0">
            <span className="font-heading font-black text-5xl md:text-7xl tracking-tighter text-outline px-6">
              {word}
            </span>
            <span className="text-[#5B7FFF] text-2xl">•</span>
          </span>
        ))}
      </div>
    </div>
  );
}
